import React, { useState, useMemo, useCallback, useEffect } from "react";
import { Tables } from "../../components/Elements/Tables/Tables";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { Badge } from "../../components/Elements/TextStyles/Badge";
import { Button } from "antd";
import SearchBar from "../../components/Elements/Search/SearchBar";
import { ReactComponent as GreenEye } from "../../assets/svgs/greenEye.svg";
import { ReactComponent as FilterIcon } from "../../assets/svgs/filter-icon.svg";
import { getApi, patchApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";
import dayjs from "dayjs";
import CustomSwitch from "../../components/Elements/CustomSwitch/CustomSwitch";
import AddNewProject from "./DailogBoxes/AddNewProject";
import { useNavigate } from "react-router-dom";
import ProjectFilter from "./DailogBoxes/ProjectFilter";
import PopupCard from "../../components/Cards/PopupCard/PopupCard";
import { useRef } from "react";
const Projects = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("");
  const [projectType, setProjectType] = useState(null);

  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const debounceTimer = useRef(null);
  const [pageSize, setPageSize] = useState(10);
  const [sortOrder, setSortOrder] = useState("-createdAt");
  const [searchTerm, setSearchTerm] = useState("");
  const [openAddNew, setOpenAddNew] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterData, setFilterData] = useState("");
  const [loadingProjectIds, setLoadingProjectIds] = useState([]);
  // const [openSuccessPopup, setOpenSuccessPopup] = useState(false);
  // const [inActivePopup, setInActivePopup] = useState(false);
  const [popup, setPopup] = useState({
    visible: false,
    type: "",
    title: "",
    message: "",
  });
  const DEBOUNCE_DELAY = 500;
  const navigate = useNavigate();

  //-------------debounce for search----------
  const handleSearch = useCallback((value) => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      setSearchTerm(value);
      setCurrentPage(1);
    }, DEBOUNCE_DELAY);
  }, []);
  
  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      {
        label: <div className="px-6">Project name</div>,
        key: "projectName",
      },
      { label: <div className="px-6">Customer name</div>, key: "customerName" },
      { label: "Start date", key: "startDate" },
      { label: "End date", key: "endDate" },
      { label: <div className="p-2">Project type</div>, key: "projectType" },
      { label: <div className="">Status</div>, key: "status" },
      { label: "Action", key: "action" },
    ],
    [],
  );

  const showPopup = (type, title, message) => {
    setPopup({ visible: true, type, title, message });

    setTimeout(() => {
      setPopup({ visible: false, type: "", title: "", message: "" });
    }, 3000); // auto-dismiss after 3s
  };

  const updateProject = async (projectId, newIsActive) => {
    setLoadingProjectIds((prev) => [...prev, projectId]);
    try {
      const response = await patchApi({
        apiUrl: API_URLS.UPDATE_PROJECT(projectId),
        data: { isActive: newIsActive },
      });
      if (response.success) {
        if (response.data.isActive === false) {
          showPopup("warning", "Status", "Project Inactivated Successfully");
        } else {
          showPopup("success", "Success", "Project Activated Successfully");
        }
        fetchTableData();
      }
    } catch (error) {
      console.error("Error in update project", error);
    } finally {
      setLoadingProjectIds((prev) => prev.filter((id) => id !== projectId));
    }
  };

  const fetchTableData = useCallback(async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GETALL_PROJECTS(
          currentPage,
          pageSize,
          sortOrder,
          searchTerm,
          filterData,
        ),
      });
      if (response.success) {
        setPageSize(response.limit);
        setTotalRecords(response.total);
        setTableData(
          response.data.map((item, index) => ({
            key: item._id,
            serial: (currentPage - 1) * response.limit + index + 1,
            projectName: item.name || "-",
            customerName: (
              <div
                style={{
                  textAlign: "center",
                  wordWrap: "break-word",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
                title=""
              >
                {item?.client_id?.organization?.name ||
                  item?.client_id?.name ||
                  item?.organization?.name ||
                  "N/A"}
              </div>
            ),
            startDate: item.startDate
              ? dayjs(item.startDate).format("DD-MM-YYYY")
              : "-",
            endDate: (
              <div title="" style={{ textAlign: "center" }}>
                {item.approval?.status === "accept"
                  ? dayjs(item.endDate).format("DD-MM-YYYY")
                  : "-"}
              </div>
            ),
            projectType: (
              <div
                style={{
                  textAlign: "center",
                  wordWrap: "break-word",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
                title=""
              >
                {item.project_type}
              </div>
            ),
            status: (
              <div className="flex justify-center" title="">
                <Badge text={item.status} />
              </div>
            ),
            action: (
              <div className="flex gap-4 items-center justify-center align-center ">
                <GreenEye
                  onClick={() => {
                    navigate("/projects/project-page", {
                      state: { projectId: item._id },
                    });
                  }}
                />
                <CustomSwitch
                  checked={item.isActive}
                  disabled={loadingProjectIds.includes(item._id)}
                  onChange={(newChecked) => updateProject(item._id, newChecked)}
                />
              </div>
            ),
          })),
        );
      }
    } catch (error) {
      console.error("Error in fetching table data", error);
    }
  }, [currentPage, pageSize, sortOrder, searchTerm, filterData, openAddNew]);

  const handleSort = useCallback(() => {
    setSortOrder((prevOrder) =>
      prevOrder === "createdAt" ? "-createdAt" : "createdAt",
    );
  }, []);

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  useEffect(() => {
    fetchTableData();
  }, [fetchTableData]);

  return (
    <div
      style={{ padding: "40px", backgroundColor: "#fff" }}
      className="h-screen"
    >
      <div>
        <div
          className="flex justify-end  text-xs"
          style={{ fontFamily: "Calibri" }}
        >
          <p>Home</p>
          <span> / </span>
          <TextStyles color="gradient"> Projects</TextStyles>
        </div>
        <div className="flex items-center  gap-2 text-xl px-2 font-bold">
          {/* <Back /> */}
          <TextStyles color="gradient"> Projects</TextStyles>
        </div>
        <div
          style={{
            border: "1px solid #3BA2B959",
            borderRadius: "10px",
            paddingTop: "20px",
            boxShadow: "0px 0px 16px 0px #3BA2B91F",
          }}
        >
          <div className="flex justify-between mb-4 px-6">
            <div className="flex gap-4">
              <div
                style={{
                  background: "#B6D4D933",
                  height: "40px",
                }}
                className="px-4   border border-gray-300 rounded-md text-gray-400 text-base font-light"
              >
                <p
                  style={{
                    fontFamily: "Calibri",
                    fontWeight: "300",
                    fontSize: "16px",
                    lineHeight: "24px",
                    letterSpacing: "0%",
                  }}
                  className="pt-2"
                >
                  TOTAL PROJECTS {totalRecords}
                </p>
              </div>
              <SearchBar
                width="300px"
                onSearch={(value) => {
                  handleSearch(value);
                }}
              />
            </div>
            <div className="flex gap-4">
              <Button
                type="primary"
                style={{ background: "#06513D" }}
                className="text-[12px] font-light hover:!bg-[#387464] px-2 py-5 "
                onClick={() => setOpenAddNew(true)}
              >
                + ADD NEW
              </Button>

              <Button
                onClick={() => setFilterOpen(true)}
                style={{ background: "#B6D4D9", border: "solid 1px #06513D" }}
                className="text-[12px] text-[#06513D] hover:!bg-[#F8F8F8] hover:!text-[#06513D] bg-[#E6EDEB] font-light px-4 py-5"
                // onClick={() => setFilterOpen(true)}
              >
                <FilterIcon /> FILTER
              </Button>
            </div>
          </div>
          <Tables
            data={tableData}
            headers={headers}
            pageSize={pageSize}
            total={totalRecords}
            current={currentPage}
            onChange={handlePageChange}
            onSort={handleSort}
          />
        </div>
      </div>
      {openAddNew && (
        <AddNewProject
          onOpen={openAddNew}
          onClose={() => setOpenAddNew(false)}
          onSave={() => {
            setOpenAddNew(false);
            showPopup("success", "Success", "Project Created Successfully");
            fetchTableData();
          }}
          onError={(err) => {
            showPopup("error", "Error !!", err || "Unable to Create Project");
          }}
        />
      )}
      {/* {openSuccessPopup && (
        <SuccessDailogBox
          onOpen={openSuccessPopup}
          onClose={() => setOpenSuccessPopup(false)}
          popuptype="success"
          successMessage={"Project Created Successfully"}
        />
      )} */}

      {filterOpen && (
        <ProjectFilter
          onOpen={filterOpen}
          onClose={() => setFilterOpen(false)}
          setFilterData={setFilterData}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          status={status}
          setStatus={setStatus}
          projectType={projectType}
          setProjectType={setProjectType}
        />
      )}

      {/* {inActivePopup && (
        <SuccessDailogBox
          onOpen={inActivePopup}
          onClose={() => setInActivePopup(false)}
          popuptype="in-active"
          successMessage={"Project Inactive Successfully"}
        />
      )} */}

      {popup.visible && (
        <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
          <PopupCard
            type={popup.type}
            title={popup.title}
            message={popup.message}
          />
        </div>
      )}
    </div>
  );
};

export default Projects;
